export default {
  excel: {
    exportModalTitle: '导出数据',
    fileType: '文件类型',
    fileName: '文件名',
    exportCurrent: '导出当前数据',
    exportAll: '导出所有数据',
    export:"导出"
  },
  form: {
    putAway: '收起',
    unfold: '展开',

    maxTip: '字符数应小于{0}位',

    apiSelectNotFound: '请等待数据加载完成...',
  },
  table: {
    settingDens: '密度',
    settingDensDefault: '默认',
    settingDensMiddle: '中等',
    settingDensSmall: '紧凑',
    settingColumn: '列设置',
    settingColumnShow: '列展示',
    settingIndexColumnShow: '序号列',
    settingFixedLeft: '固定到左侧',
    settingFixedRight: '固定到右侧',
    settingFullScreen: '全屏',
    settingBordered: '边框',
    index: '序号',
    total: '共 {total} 条数据',
    allLabel: '全部',
    YesLabel: '是',
    NoLabel: '否',
    settingOrder: '排序设置',
    union: '联合排序',
    confirm: '确定',
    cancel: '取消',
    Ascending: '升序',
    Descending: '降序',
    singleAscending: '单独排序',
    fullScreen: '全屏',
    exitFullScreen: '退出全屏',
    IntWarning: '请在{1}中输入正确的整型值',
    LengthWarning: '{1}的长度超过最大值，请重新输入',
    FloatWarning: '请在{1}中输入正确的浮点数',
    batchQueryItem: '批量查询条件',
    selectColInfo: '请选择查询列',
    editInDlg: '在弹窗中编辑',
    show: '查看',
    showInDlg: '详细信息',
    validWarning:"请检查界面数据",
    InputWarn:"请输入",
    SelectWarn:"请选择"
  },
};
